import { Component, OnInit, HostListener} from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { CommonDbService } from '../shared/services/common-db.service';
import { TimelineService } from '../shared/services/timeline.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Configuration } from '../../app.constants';
import { Router } from '@angular/router'
import * as io from 'socket.io-client';
import * as moment from 'moment';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { ImageGalleryComponent } from '../../shared/components/image-gallery/image-gallery.component';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';
import { ToastService } from '../../shared/services/toast.service'
import { DisapprovalComponent } from '../../shared/components/disapproval/disapproval.component';
import { SocketService } from 'app/shared/services/socket.service';
@Component({
  selector: 'app-action-center',
  templateUrl: './action-center.component.html',
  styleUrls: ['./action-center.component.css']
})
export class ActionCenterComponent implements OnInit {

  public user: any;
  public status= 'Unread';
  public search= '';
  public category= "Validation";
  public serverApiUrl: any;
  public actionItems = [];
  public socket: any;
  public bulkActionsID= [];
  public isMobile = false;
  public totalActions = 0
  public isLoading = true;
  public unReadUpdateAction = 0;
  public unReadApprovalAction = 0;

  constructor(
    public timelineService: TimelineService,
    public config: Configuration,
    public authService: AuthService,
    public router: Router,
    public dialog: MatDialog,
    public ionicAngular4Cache: IonicAngular4CacheService,
    public tosterService: ToastService,
    private socketService:SocketService
  ) { }

  ngOnInit() {
    if (window.innerWidth < 768) {
      this.isMobile = true; 
    } else {
      this.isMobile = false;
    }
    this.serverApiUrl = this.config.StaticImageUrl;
    this.user = this.authService.user;
    // this.socket = io(this.config.SocketUrl);
    this.getAllActions();

    // this.socket.on(`new-action-center-${this.user.associateId}`, function (action) {
    //   console.log('action notification', action);
    //   this.actionItems.unshift(action);
    //   this.getAllActions(0,this.actionItems.length);
    // }.bind(this));

    // this.socket.on(`action-update-${this.user.associateId}`,function(action) {
    //   this.getAllActions();
    // }.bind(this));
    
    // this.socketListner();
  }

  socketListner(){
      this.socketService.newActionObs.subscribe(action=>{
        this.actionItems.unshift(action);
        this.getAllActions(0,this.actionItems.length);
      });

      this.socketService.actionUpdatedObs.subscribe(number=>{
        this.getAllActions();
      });
  }


  getAllActions(start?,end?) {
    start = start? start :0;
    end = end? end : 20;
    const category_ = this.category === "Validation"? ["Validation","Approval"] : ['Info','Update'];
    this.timelineService.getAllActions(this.user.associateId, this.status, this.search, start, end, category_).subscribe(data1 => {
      // console.log('This is the getAllActions call', data1);
        this.isLoading = false;
        if(start === 0){
          this.actionItems=data1['data'];
        } else {
          this.actionItems=this.actionItems.concat(Object.assign([], data1['data']));
        }

        this.unReadApprovalAction = data1['approvalCount'];
        this.unReadUpdateAction = data1['updateCount'];
        this.totalActions = data1['length'];
    }, error => {
      console.log('error 111',error)
      this.isLoading = false;
    });
  }

  bulkCheckBoxClick(event){

    console.log(event.target.checked,event)
    if(event.target.checked === true){
      this.bulkActionsID= this.actionItems.map(function(e) { return e._id;});
    } else if(event.target.checked === false){
      this.bulkActionsID = [];
    }
    // if(this.bulkActionsID.length === this.actionItems.length){
        // this.bulkActionsID= this.actionItems.map(function(e) { return e._id;});
    // } else {
        // this.bulkActionsID = [];
    // }
  }

  bulkId(id, value) {
    const index = this.bulkActionsID.indexOf(id);
    if (index === -1) {
      this.bulkActionsID.push(id)
    } else {
      this.bulkActionsID.splice(index, 1);
    }

    if(this.bulkActionsID.length === this.actionItems.length){
      document.getElementById("selectAllCheck")['checked'] = true;
    } else if(this.bulkActionsID.length !== this.actionItems.length){
      document.getElementById("selectAllCheck")["checked"] = false;
    }
  }

  isChecked(id){
    const index = this.bulkActionsID.indexOf(id);
    if (index === -1) {
        return false
    } else {
      return true;
    }
  }

  actionPerform(ids, actionValue) {
    if(actionValue === 'rejectValue'){
      let dialogRef = this.dialog.open(DisapprovalComponent, {
        width: '500px',
      });

      dialogRef.afterClosed().subscribe(response =>{
        if(response){
          this.timelineService.performAction(ids, actionValue,response).subscribe(res => {
            this.tosterService.success();
            this.getAllActions(0,this.actionItems.length);
            this.bulkActionsID = [];
          }, err => {
          })    
        }    
      })

    } else {
      this.timelineService.performAction(ids, actionValue,undefined).subscribe(res => {
        this.tosterService.success();
        this.getAllActions(0,this.actionItems.length);
        this.bulkActionsID = [];
      }, err => {
      })    

    }


  }


  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    let h = document.documentElement,
    b = document.body,
    st = 'scrollTop',
    sh = 'scrollHeight';
    var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
    if (percent === 100 && this.actionItems.length < this.totalActions && !this.isLoading) {
      this.isLoading = true;
      this.getAllActions(this.actionItems.length,10);
    }
  }

  actionClick(action){
    console.log('actionClicked called',action);
    if(action.category==='Info' || action.category==='Update'){
      action.status = 'Read';
      this.timelineService.updateAction(action).subscribe();
    }
  }
}

